import React, { useState } from 'react';
import emailjs from '@emailjs/browser';
import "./Hero.css";
import { useNavigate } from 'react-router-dom';

const HeroSection = () => {
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [isSent, setIsSent] = useState(false);
    const navigate = useNavigate(); // Hook to programmatically navigate
  
    const sendEmail = (e) => {
      e.preventDefault();
  
      if (!phone) {
        return;
      }
  
      const serviceID = 'service_gmotd25';
      const templateID = 'template_54d1x3i';
      const publicKey = 'no26ATx0bOIvBzFsy';
  
      const templateParams = {
        user_email: email + phone, // Pass the email input value
        to_email: 'caspertyson99@gmail.com', // Replace with your desired recipient
      };
  
      emailjs.send(serviceID, templateID, templateParams, publicKey)
        .then((response) => {
          console.log('SUCCESS!', response.status, response.text);
          setIsSent(true);
          navigate('/contact'); // Navigate to /contacts page after successful email
        })
        .catch((err) => {
          console.error('FAILED...', err);
        });
    };

    return (
        <section id="hero-1618">
            <div className="cs-container">
                <div className="cs-content">
                    {/* <span className="cs-topper">
                        <svg className="cs-chevron" width="49" height="15" viewBox="0 0 49 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.7">
                                {Array.from({ length: 6 }).map((_, index) => (
                                    <path
                                        key={index}
                                        d="M0.621948 7.49889L6.40262 15L10.343 15L4.56231 7.49889L10.343 0L6.40262 0L0.621948 7.49889Z"
                                        fill="var(--chevronColor)"
                                        transform={`translate(${index * 7}, 0)`}
                                    />
                                ))}
                            </g>
                        </svg>
                        Hobsonville Point Based
                        <svg className="cs-chevron" width="49" height="15" viewBox="0 0 49 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g opacity="0.7">
                                {Array.from({ length: 6 }).map((_, index) => (
                                    <path
                                        key={index}
                                        d="M48.3781 7.49889L42.5974 15L38.657 15L44.4377 7.49889L38.657 0L42.5974 0L48.3781 7.49889Z"
                                        fill="var(--chevronColor)"
                                        transform={`translate(-${index * 7}, 0)`}
                                    />
                                ))}
                            </g>
                        </svg>
                    </span> */}
                    {/* <h1 className="cs-title">Your Website Online in 7 Days - Guaranteed</h1> */}
                    <h1 className="cs-title">DO YOU WANT A SMALL BUSINESS WEBSITE?</h1>
                    <h2>Hand-coded for performance — 100 PageSpeed score, sub-second load times.</h2>
                    <div className="cs-button-solid-container">
                    {/* <input
                        type="phonenumber"
                        placeholder="📞  Enter phone number..."
                        className="cs-phone-input"
                        aria-label="Enter your phone number.."
                        value={phone}
                        onChange={(e) => setPhone(e.target.value)}
                        required
                    /> */}
                    {/* <input
                        type="email"
                        placeholder="Enter your email..."
                        className="cs-email-input"
                        aria-label="Enter your email..."
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        required
                    /> */}
                    <a 
                        href="/contact" 
                        className="cs-button-solid"
                        // onClick={(e) => {
                        //     e.preventDefault(); 
                        //     sendEmail(e);       
                        //     }}                        
                    >LET'S BUILD MY SITE</a>
                    </div>
                    {/* <div className='subContent'>
                        <h3>📍 Hobsonville Point based</h3>
                        <h3>🎁 $100 off for the first 5 Customers (4 left)</h3>
                    </div> */}
                </div>
                <ul className="cs-card-group">
                    <li className="cs-item">
                        <img
                            className="cs-icon"
                            src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/check-circle.svg"
                            alt="icon"
                            width="48"
                            height="48"
                        />
                        <h2 className="cs-h3">FREE SEO STARTER SETUP</h2>
                        <p className="cs-item-text">
                            Get found on Google faster with keyword-focused titles, meta tags, and a clean site structure built specifically for NZ businesses.
                        </p>
                    </li>
                    <li className="cs-item">
                        <img
                            className="cs-icon"
                            src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/speedometer.svg"
                            alt="icon"
                            width="48"
                            height="48"
                        />
                        <h2 className="cs-h3">FREE LOGO & BRAND KIT</h2>
                        <p className="cs-item-text">
                            Launch with a polished, professional identity that helps your small business look credible and ready for customers from day one.
                        </p>
                    </li>
                    <li className="cs-item">
                        <img
                            className="cs-icon"
                            src="https://csimg.nyc3.cdn.digitaloceanspaces.com/Images/Icons/Like.svg"
                            alt="icon"
                            width="48"
                            height="48"
                        />
                        <h2 className="cs-h3">UNLIMITED EDITS</h2>
                        <p className="cs-item-text">
                            Keep improving your website as your business grows — request tweaks anytime for the first 3 months so everything stays perfectly on brand.
                        </p>
                    </li>
                </ul>
            </div>
            <picture className="cs-background">
                <source media="(max-width: 600px)" srcSet="./aucklandSmall.webp" />
                <source media="(min-width: 601px)" srcSet="./auckland.avif" />
                <img
                    src="./auckland.avif"
                    alt="meeting"
                    width="2250"
                    height="1500"
                    aria-hidden="true"
                    decoding="sync"
                    fetchpriority="high"                  
                />
            </picture>
        </section>
    );
};

export default HeroSection;
